export enum ECollapsable {
  BOTH = 'both',
  MOBILE = 'mobile',
  DESKTOP = 'desktop',
  NONE = 'none',
}
